<template>
	<v-row align="center" justify="center">
		<v-col cols="12" sm="12" md="12">
			<!-- <h1 class="mx-auto white--text text-center">Accept Invite</h1> -->
			<auth-type></auth-type>
		</v-col>
	</v-row>
</template>

<script>
import AuthType from '@/components/invite/AcceptInviteAuthType.vue';

export default {
	components: {
		AuthType,
	},
};
</script>

<style></style>
